<button
  class="rounded-md bg-ocean-blue-50 px-2 py-1 text-xs leading-relaxed font-medium break-words text-ocean-blue-500 md:text-sm"
  [disabled]="!isClickable()"
  [class.hover:bg-ocean-blue-200]="isClickable()"
  (click)="onClick($event)"
  (keydown.enter)="onClick($event)"
  tabindex="0"
>
  <span class="inline-flex items-center gap-1 align-middle">
    <span class="break-words" [class.hover:underline]="isClickable()">{{
      category().title
    }}</span>
    @if (isClickable()) {
      <img
        class="inline-block h-[1em] w-[1em]"
        ngSrc="assets/icons/book-content.svg"
        alt="Manual Icon"
        height="16"
        width="16"
      />
    }
  </span>
</button>
